import { DataSourceAction, DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutExchangeRateQuickInfo } from "./autogen/AutogenLayoutExchangeRateQuickInfo";
import { ModelRow } from "@mcleod/core";

export class ExchangeRateQuickInfo extends AutogenLayoutExchangeRateQuickInfo {

    private convertObjectToModelRow(modelUrl: string, data: []): ModelRow[] {
        const modifiedData: ModelRow[] = [];
        if (data == null) {
            return modifiedData;
        }

        for (const d of data) {
            const modelRow = new ModelRow(modelUrl, false, d);
            modifiedData.push(modelRow);
        }

        return modifiedData;
    }

    sourceCurrencyConversionsAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() === DataSourceAction.SEARCH) {
            this.sourceCurrencyConversions.data = this.convertObjectToModelRow("lme/general/multicurrency/currency-conversions",
                this.sourceCurrencyConversions.data[0]?.get("exchange_rate_data"));
            this.sourceCurrencyConversions.displayDataInBoundComponents();
        }
    }
}
